import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { FolderRedirectLoader } from '@confluence/folder/entry-points/FolderRedirectLoader.ts';
import { FolderContainerLoader } from '@confluence/folder/entry-points/FolderContainerLoader.ts';
import { expVal } from '@confluence/feature-experiments';

export const FolderViewRoute: {
	({ params: { contentId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					contentId: string;
				};
			};
			pageState: {
				contentId: string;
				spaceKey: string;
				contentSlug: string;
				contentType: string;
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = ({ params: { contentId } }: RouteMatch): React.JSX.Element =>
	expVal('confluence_folder_view', 'isEnabled', false) ? (
		<FolderContainerLoader contentId={contentId} />
	) : (
		<FolderRedirectLoader contentId={contentId} />
	);

FolderViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey, contentSlug },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				contentId: string;
			};
		};
		pageState: {
			contentId: string;
			spaceKey: string;
			contentSlug: string;
			contentType: string;
			routeName: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
		isViewPage: boolean;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'folderScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentSlug,
			contentType: 'folder',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
